import { Analytics } from 'features/Analytics/Analytics';
import React from 'react';
import { Outlet } from 'react-router-dom';

function LoginLayout() {
	return (
		<>
			<Outlet />
			<Analytics />
		</>
	);
}

export default LoginLayout;
